import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import LoggedIn from './LoggedIn';
import { AuthContext } from '../../Auth';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import WhmcsApi from '../../services/WhmcsApi';
import { useSelector } from 'react-redux';
import axios from 'axios';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs() {
    const [value, setValue] = React.useState(0);
    const { userAuth, setUserAuth } = useContext(AuthContext);
    const { t } = useTranslation();
    const resumenData = useSelector(state => state.global.ResumenData);
    const countCart = resumenData.filter(item => item.actual === false).length;
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }; 

    useEffect(() => {        
        const fetchUpdateCartCount = async () => {         
            const whmcsApi = new WhmcsApi(); // Crear instancia de WhmcsApi
            await whmcsApi.request('updateCartCount',{count: countCart}, 'POST', null);
        }; 
        
        fetchUpdateCartCount(countCart)
      }, [countCart]);

    return (
        <Card variant="outlined">
            {!userAuth ? (
                <Box variant="outlined" sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs 
                        value={value} 
                        onChange={handleChange} 
                        aria-label="login tabs"  
                        variant="fullWidth" //esta propiedad fue la chida para ajustar al 50/50
                        sx={{ bgcolor: 'background.paper', width: '100%' }}          
                        >
                            <Tab
                                label={t("loginbase.loginTitle")}
                                {...a11yProps(0)}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: 16,
                                    fontFamily: 'patua one',
                                    backgroundColor: value === 0 ? 'white' : '#F3F4F5',
                                    color: value === 0 ? 'black' : '#64748B',
                                    width: '55%',

                                }}
                            />
                            <Tab
                                label={t("loginbase.signupTitle")}
                                {...a11yProps(1)}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: 16,
                                    fontFamily: 'patua one',
                                    backgroundColor: value === 1 ? 'white' : '#F3F4F5',
                                    color: value === 1 ? 'black' : '#64748B',
                                    width: '65%',
                                }}
                            />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <LoginForm setValue={setValue}></LoginForm>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <RegisterForm setValue={setValue}></RegisterForm>
                    </CustomTabPanel>
                </Box>
            ) : (
                <LoggedIn></LoggedIn>
            )}
        </Card>
    );
}
